import React from 'react'

import { Article, PartialCategory, PartialSection } from '@doist/help-center-utils'
import { Breadcrumbs, Container, Hairline, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import { TagList } from '../TagList/TagList'

import css from './IntroSection.module.css'

type IntroSectionProps = {
    article: Article
    category: PartialCategory
    section: PartialSection
}

export function IntroSection({ article, category, section }: IntroSectionProps) {
    const { t } = useTranslation('helpcenter')

    const items: { text: string; href: string }[] = []
    if (category) {
        items.push({ text: category.name, href: category.href })
    }
    if (section) {
        const sectionName = section.id === 0 ? t('allIntegrations') : section.name
        items.push({ text: sectionName, href: section.href })
    }

    return (
        <Container className={css.introSection} padded>
            {items.length > 0 && <Breadcrumbs className={css.breadcrumbs} items={items} />}

            <Text tag="h1" size="major-lg">
                {article.title}
            </Text>

            {article.platforms.length > 0 && (
                <TagList
                    className={css.metaInfo}
                    title={t('article.platforms')}
                    platforms={article.platforms.map((p) => t('article.' + p))}
                />
            )}

            <Hairline />
        </Container>
    )
}
